<template>
  <div class="px-2 d-flex flex-column">

    <div v-if="isLoading" class="mt-5">
        <loading class="mt-5"/>
    </div>

    <div v-else>

        <!-- Header -->
        <div style="position:absolute; z-index:2; width:75%">
            <div class="d-flex justify-content-between">
                <div class="d-flex">

                    <!-- Filtros de busqueda -->
                    <filtro-planificacion-anual v-if="this.usuarioActual.rol != 'Cliente'" class="mr-2"/>

                    <nueva-planificacion-anual-modal />

                    <!-- Descargar Plantilla en Blanco de Planificación Excel -->
                    <Button
                        v-if="isDownload"
                        :size="15"
                        color="#28a745"
                        colorText="#ffffff"
                        tooltip="Descargar Plantilla en Blanco de Planificación Excel"
                        icon="fas fa-file-download"
                        round
                        :width="30"
                        class="mr-2"
                        inactive
                    />

                    <Button
                        v-else
                        :size="15"
                        color="#28a745"
                        colorText="#ffffff"
                        tooltip="Descargar Plantilla en Blanco de Planificación Excel"
                        icon="fas fa-file-download"
                        round
                        :width="30"
                        class="mr-2"
                        @click.native="descargarPlantillaPlanificacionAnual()"
                        traslate
                    />

                    <Button
                    :size="15"
                    color="#28a745"
                    colorText="#ffffff"
                    tooltip="Exportar a Excel"
                    icon="icon fas fa-file-excel"
                    round
                    :width="30"
                    class="mr-2"
                    @click.native="actionSetPAShowReportModal(true)"
                    traslate
                    />

                    <!--Modal de gestion de planes semanales -->
                    <reporte-planificacion-anual-modal/>

                    <!-- Acciones multiples -->
                    <eliminar-planificacion-anual-modal :data="dataMultipleSeleccionada"/>

                </div>
            </div>
        </div>

        <!-- Body -->
        <data-table
            :headers="headers"
            :data="dataAux"
            :acciones="acciones"
            :max="10"
            paginacion
            buscar
            idtabla="planificacion_anual_lineas"
            check
            :seleccionar="obtenerFilaSeleccionada"
            :filaChekeada="obtenerFilaCheckeada"
        />

        <informacion-general-planificacion-anual :data="dataDetalle"/>
    
    </div>

  </div>
</template>

<script>

    // Vue
    import Vue from "vue";

    // Toast
    import VueToastify from "vue-toastify";
    Vue.use(VueToastify);

    // Vuex
    import { mapActions, mapState } from "vuex";
    import { getPlanificacionAnual, getPlantillaPlanificacionAnual } from '../../../constants/lineas';

    // Componentes
    import Button from '../../common/Button'
    import DataTable from '../../common/DataTable'

    // Vistas
    import FiltroPlanificacionAnual from '../../filtros/lineas/FiltroPlanificacionAnual'
    import NuevaPlanificacionAnualModal from '../../modals/lineas/NuevaPlanificacionAnualModal';
    import InformacionGeneralPlanificacionAnual from '../../modals/lineas/InformacionGeneralPlanificacionAnual';
    import EliminarPlanificacionAnualModal from '../../modals/lineas/planificacionAnual/EliminarPlanificacionAnualModal.vue';
    import ReportePlanificacionAnualModal from "@/components/modals/lineas/planificacionAnual/ReportePlanificacionAnualModal.vue";
    import Loading from '../../common/loading.vue';

    export default {

        components: {
            ReportePlanificacionAnualModal,Button, FiltroPlanificacionAnual, DataTable, InformacionGeneralPlanificacionAnual,
            NuevaPlanificacionAnualModal,EliminarPlanificacionAnualModal,Loading
        },

        data() {
            return {
                headers : ['Año', 'Empresa', 'Contenedor', 'Producto','Consignatario', 'Serv. Integral', 'Total anual', 'Fecha creación', 'Última modificación','Acciones'],
                dataMultipleSeleccionada : [],
                acciones: [],
                dataAux : [],
                dataDetalle: [],
                isDownload: false,
                isLoading: true,
                idSelected: null,
            };
        },

        computed : {
            ...mapState(['usuarioActual']),
            ...mapState('lineas',["dataPlanificacionAnualTabla","dataFiltradaPlanificacionAnual"])
        },

        methods : {

            ...mapActions("lineas", ['actionSetVisibleModalInformacionPlanificacionAnual','actionSetLista_productos',
                                     'actionSetLista_contenedores','actionSetLista_consignatarios', 'actionSetPAShowReportModal',
                                     'actionSetLista_puertos','actionSetProduct_selected','actionSetContainer_selected',
                                     'actionSetAnnual_plan_id','actionSetListaAnios','actionSetListaClientes','actionSetListaServIntegral',
                                     'actionSetYearsFilter','actionSetClienstFilter','actionSetContainersFilter','actionSetProductsFilter',
                                     'actionSetServIntegralFilter','actionSetConsigneeFilter','actionSetPortFilter', 'actionSetListaAniosACopiar', 'actionSetListaClientesPap', 'actionSetListaClientesApe']),

            obtenerFilaSeleccionada(data){

                let { id, accion } = data;

                switch (accion) {

                    case 'Modificar planificación':

                        this.dataDetalle = this.dataAux[id];
                        this.idSelected = id;

                        this.actionSetProduct_selected(this.dataAux[id].data_complementaria.product_selected);
                        this.actionSetContainer_selected(this.dataAux[id].data_complementaria.container_selected);
                        this.actionSetAnnual_plan_id(this.dataAux[id].data_complementaria.annual_plan_id);
                        this.actionSetVisibleModalInformacionPlanificacionAnual(true);

                        break;
                
                    default:
                        break;
                }

            },

            obtenerFilaCheckeada(data){

                let {id, estado} = data;
                let filtrada = [] ;

                if (estado) {
                    this.dataMultipleSeleccionada.push({id, data : this.dataAux[id]});
                } else {
                    this.dataMultipleSeleccionada.filter((item) => item.id != id && filtrada.push(item));
                    this.dataMultipleSeleccionada = filtrada;
                }

            },

            async generarBotonesAcciones() {

                this.acciones = [];

                await this.dataAux.map((_, index) => {
                    this.acciones.push([
                        {
                            icon: "fa fa-edit",
                            title: "Modificar planificación",
                            id: index,
                        },
                    ]);
                });

                this.isLoading = false;

            },

            async ObtenerPlanificacionesAnuales(){

                let sql = await getPlanificacionAnual();

                if (sql.code == 200) {
                   
                    let { data, containers_list, consignees_list, ports_list, years_list, years_to_copy, customers_list, customers_pap_list, customers_ape_list,integral_s_list,
                          years_filter, customers_filter, containers_filter, products_filter, integral_s_filter, consignees_filter, ports_filter} = sql;

                    this.dataAux = data;

                    this.actionSetListaAnios(years_list);
                    this.actionSetListaAniosACopiar(years_to_copy);
                    this.actionSetListaClientes(customers_list);
                    this.actionSetListaClientesPap(customers_pap_list);
                    this.actionSetListaClientesApe(customers_ape_list);
                    this.actionSetLista_contenedores(containers_list);
                    this.actionSetLista_productos(products_filter);
                    this.actionSetLista_consignatarios(consignees_list);
                    this.actionSetListaServIntegral(integral_s_list);
                    this.actionSetLista_puertos(ports_list);

                    this.actionSetYearsFilter(years_filter);
                    this.actionSetClienstFilter(customers_filter);
                    this.actionSetContainersFilter(containers_filter);
                    this.actionSetProductsFilter(products_filter);
                    this.actionSetServIntegralFilter(integral_s_filter);
                    this.actionSetConsigneeFilter(consignees_filter);
                    this.actionSetPortFilter(ports_filter);

                    this.generarBotonesAcciones();

                }

            },

            async descargarPlantillaPlanificacionAnual(){

                this.isDownload = true;

                this.$vToastify.loader('Generando plantilla de planificación');

                let response = await getPlantillaPlanificacionAnual();

                if (response.status == 200) {

                    const url  = window.URL.createObjectURL(new Blob([response.data])) ;
                    const link = document.createElement('a');
                    
                    link.href  = url ;
                    link.setAttribute('download', 'Planificación Anual.xlsx');
                    document.body.appendChild(link)
                    link.click();

                    this.$vToastify.stopLoader();
                    this.$vToastify.success("Plantilla descargada", "¡Exito!");

                    this.isDownload = false;
                    
                } else {
                    
                    this.$vToastify.stopLoader();
                    this.$vToastify.error( "Error al generar plantilla", "Contactar a soporte");

                    this.isDownload = false;

                }
                
               

            }

        },

        created(){
            this.ObtenerPlanificacionesAnuales();
        },

        watch : {

            dataPlanificacionAnualTabla : function(_new){

                if (_new.code == 200) {
                   
                    let { data, products_filter, containers_list, consignees_filter, ports_list } = _new;

                    this.dataAux = data;

                    this.actionSetLista_productos(products_filter);
                    this.actionSetLista_contenedores(containers_list);
                    this.actionSetLista_consignatarios(consignees_filter);
                    this.actionSetLista_puertos(ports_list);

                    this.generarBotonesAcciones();

                    this.dataMultipleSeleccionada = [];
                    this.dataDetalle = this.dataAux[this.idSelected];
                }

            },

            dataFiltradaPlanificacionAnual : function(_new){
                _new && _new.length && (this.dataAux = _new);
            },

        }
    }
    
</script>

<style>

</style>